import { useSelector } from "react-redux";
import { SERVER_URL } from "../api";

function buildAvatarUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

/**
 * Lee la URL del avatar del paciente desde la caché de Redux (gameTexts).
 * Así no hace fetch extra y no hay parpadeo cuando ya precargamos los textos.
 */
export function usePatientImage(gameId) {
	const texts = useSelector((state) =>
		gameId && state.gameTexts?.[gameId] ? state.gameTexts[gameId] : {}
	);
	const hasTexts = Object.keys(texts).length > 0;
	const url = hasTexts ? buildAvatarUrl(texts["avatar.patient"]) : null;
	const ready = !gameId || hasTexts;

	return { patientImageUrl: url, ready };
}
